import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import type { PageWarranty } from '../../api/api-types';
import type { Loadable, Loaded } from '../../guards/ngrx-loader.guard';
import { actions } from './warranty.actions';

interface Content {
    content: Loadable<PageWarranty>;
}

const initialState: Content = {
    content: null,
};

export const state = createFeature({
    name: 'warrantyPage',
    reducer: createReducer(
        initialState,
        on(
            actions.loadPageWarranty,
            (state): Content => ({
                ...state,
                content: null,
            }),
        ),
        on(
            actions.loadPageWarrantySuccess,
            (state, { content }): Content => ({
                ...state,
                content: content,
            }),
        ),
    ),
    extraSelectors: (baseSelectors) => {
        const selectIsLoadingWarranty = createSelector(baseSelectors.selectContent, (content) => content === null);
        const selectLoadedContent = createSelector(
            baseSelectors.selectContent,
            (content) => content as Loaded<PageWarranty>,
        );
        return {
            selectIsLoadingWarranty,
            selectLoadedContent,
        };
    },
});
